var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9977 7.72283C17.9983 8.02072 17.8939 8.30941 17.7026 8.53878C17.5949 8.66788 17.4627 8.77459 17.3134 8.85281C17.1641 8.93103 17.0008 8.97922 16.8328 8.99461C16.6648 9.01001 16.4953 8.99231 16.3342 8.94253C16.1731 8.89275 16.0234 8.81187 15.8938 8.70452L9.01759 2.99287L2.12859 8.50054C1.99736 8.60644 1.84637 8.68552 1.6843 8.73325C1.52222 8.78097 1.35225 8.79639 1.18416 8.77862C1.01607 8.76084 0.853166 8.71023 0.704819 8.62969C0.556472 8.54915 0.425605 8.44027 0.319739 8.3093C0.202951 8.17739 0.11486 8.02291 0.0609931 7.85556C0.00712662 7.68821 -0.0113515 7.5116 0.00671761 7.33682C0.0247867 7.16204 0.0790132 6.99285 0.165994 6.83988C0.252975 6.68691 0.370832 6.55346 0.512169 6.44791L8.20939 0.290029C8.43893 0.102511 8.72686 -3.81463e-07 9.02401 -3.94452e-07C9.32115 -4.07441e-07 9.60908 0.102511 9.83863 0.290029L17.5358 6.66465C17.6911 6.79254 17.8138 6.95501 17.8941 7.13887C17.9743 7.32272 18.0098 7.52279 17.9977 7.72283Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.svg";
export { ForwardRef as ReactComponent };